// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE MONTHLY-PAYMENT LINES (Jesse/Hannah, 2026-11-01). A MIRROR of backend utils/monthlyPayment paymentBreakdown's
// rounding: the total is the exact sum rounded to the dollar; P&I is rounded as the LE prints it and the other parts
// absorb the rounding so the four sum to the total (largest remainder). The card prefers the decision's STORED breakdown (est.payment_breakdown) when it is for the price shown;
// this mirror only re-prices the card live (another price, a buydown). backend/test/smartEstimatePaymentBreakdown.test.js
// holds the two to the same answers.
// ─────────────────────────────────────────────────────────────────────────────

function spread(exact, keys, target) {
  const out = Object.fromEntries(keys.map((k) => [k, Math.floor(exact[k])]));
  let gap = target - keys.reduce((t, k) => t + out[k], 0);
  const frac = (k) => exact[k] - Math.floor(exact[k]);
  const up = keys.slice().sort((a, b) => frac(b) - frac(a));
  for (let i = 0; gap > 0 && i < up.length * 4; i += 1) { out[up[i % up.length]] += 1; gap -= 1; }
  const down = keys.slice().sort((a, b) => frac(a) - frac(b));
  for (let i = 0; gap < 0 && i < down.length * 4; i += 1) { const k = down[i % down.length]; if (out[k] > 0) { out[k] -= 1; gap += 1; } }
  return out;
}

export function linesFrom({ pi, tax, hoi, hoa = 0 }) {
  const exact = { pi: Number(pi) || 0, tax: Number(tax) || 0, hoi: Number(hoi) || 0, hoa: Number(hoa) || 0 };
  const total = Math.round(exact.pi + exact.tax + exact.hoi + exact.hoa);
  // P&I as the LE prints it (rounded); taxes, insurance and HOA absorb the rounding so the four sum to the total.
  return { pi: Math.round(exact.pi), ...spread(exact, ['tax', 'hoi', 'hoa'], total - Math.round(exact.pi)), mi: 0, total };
}

/** The lines the card shows: the stored breakdown when it is for this price and no buydown re-priced P&I. */
export function cardPaymentLines({ stored, price, buydownPI = null, pi, tax, hoi, hoa = 0 }) {
  if (stored && buydownPI == null && Math.round(Number(stored.price)) === Math.round(Number(price))
    && ['pi', 'tax', 'hoi', 'hoa', 'total'].every((k) => Number.isFinite(Number(stored[k])))) {
    return { pi: Number(stored.pi), tax: Number(stored.tax), hoi: Number(stored.hoi), hoa: Number(stored.hoa), mi: 0, total: Number(stored.total), source: 'stored' };
  }
  return { ...linesFrom({ pi: buydownPI != null ? buydownPI : pi, tax, hoi, hoa }), source: 'live' };
}
